<template>
  <div class="container">
    <main-menu></main-menu> 
    <div class="row">
      <div class="col-sm-12 col-12 col-lg-12">
        <h6 class="font-weight-normal pt-3"> 我加入的群博</h6>
        <div class="text-center mt-5" v-if="groupbloglists.length==0">
          <h5>您的文件夹是空的, 您没有加入任何群博</h5>
        </div>
        <template v-if="groupbloglists.length>0">
          <div v-for="item in groupbloglists"
            v-bind:key="item.id" class="d-flex py-3" style="border-bottom:1px solid #eee;">
            <div id="avatar">
              <router-link :to="'/blog/user/'+item.userinfo_blogger_userID.id">
                <div v-if="!item.userinfo_blogger_userID.avatar" class="avatar-word" :style="{height:'48px',width:'48px',lineHeight:'48px',minWidth:'48px'}">{{item.userinfo_blogger_userID.first_letter}}</div>
                <img 
                  :style="{height:'48px',minWidth:'48px'}"
                  v-if="item.userinfo_blogger_userID.avatar" 
                  v-bind:alt="item.userinfo_blogger_userID.username" 
                  class="rounded-circle" 
                  v-bind:src="item.userinfo_blogger_userID.avatar" 
                  >
              </router-link>
            </div>
            <div class="flex-fill" style="line-height:48px;padding-left:8px">{{item.userinfo_blogger_userID.username}}</div>
            <div class="func">
              <el-popconfirm
                confirm-button-text='退出'
                cancel-button-text='取消'
                icon="el-icon-info"
                icon-color="red"
                title="您确定要退出吗？"
                @confirm="remove(item.bloggerID)"
              >
                <el-button type="text" style="color:gray" slot="reference">退出群博</el-button>
              </el-popconfirm>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import MainMenu from '../components/Main/MainMenu';
// import ArticleListItem from '../components/Main/ArticleListItem.vue';

export default {
  name: 'groupblog',
  components: {
    MainMenu,
    // ArticleListItem,
  },
  mounted:function(){
    this.getGroupBlogList();
  },
  data() {
    return {
        user:this.$store.state.user,
        groupbloglists:[]
    };
  },
  methods:{
    async getGroupBlogList(){
      let v = await this.user.get_group_blog_list()
      if(v.status){
        this.groupbloglists = v.data;
      }else{
        this.groupbloglists = [];
      }
    },
    async logoutGroupBlog(bloggerID){
      let v = await this.user.group_join_delete(bloggerID);
      if(v.status){
        this.getGroupBlogList()
      }
    },
    remove(bloggerID) {
        
      this.user.group_join_delete(bloggerID).then(res=>{
        if(res.status){
          this.getGroupBlogList();
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
        }
      })
       
    }
  }
};
</script>
<style>
#avatar .avatar-word{
    border-radius: 50%;
    background-color: aliceblue;
    text-align: center;
    font-weight: 500;
}
</style>
